import { createSelector } from 'reselect';
import { CRUDSelectors } from '../crudCreator/selectors';
import { MODEL_NAME } from './actions';

export const contactsSelectors = new CRUDSelectors(MODEL_NAME);

const getDataParentProfile = (state) => state.contacts.currentData;
const getDataApplicationsSummary = (state) =>
  state.contacts.summaryDetail?.applicationSummary;

const getDataEnquriesSummary = (state) =>
  state.contacts.summaryDetail?.enquirySummary;

export const getParentProfileData = createSelector(
  getDataParentProfile,
  (data) => data,
);

export const getApplicationsSummaryData = createSelector(
  getDataApplicationsSummary,
  (data) => data,
);

export const getEnquiriesSummaryData = createSelector(
  getDataEnquriesSummary,
  (data) => data,
);
